import { render, staticRenderFns } from "./rematcher.vue?vue&type=template&id=7d06c44c&"
import script from "./rematcher.vue?vue&type=script&lang=js&"
export * from "./rematcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports